// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__YXoBY","large":"styles_large__1o-VV"};